export default __webpack_public_path__ + "static/media/cylinder2.ba5e7998.svg";